export const PEGMAN_SIZE_PX = 36;

// gap between the pegman and the other column
export const PEGMAN_NEIGHBOR_GAP_PX = 12;
